import { PreferencesView } from "@secure-vault/ui";
import { useTheme } from "next-themes";
import { toast } from "sonner";

import {
  useUpdateUserSettings,
  useUserSettings,
} from "@/hooks/use-user-settings";

export function PreferencesContainer() {
  const { data: user, isLoading } = useUserSettings();
  const { mutate, isPending } = useUpdateUserSettings();
  const { theme = "system", setTheme } = useTheme();

  const handleDateFormatChange = (dateFormat: string) => {
    mutate(
      { preferences: { date_format: dateFormat } },
      {
        onSuccess: () => toast.success("Preferences saved."),
        onError: () => toast.error("Failed to save preferences."),
      }
    );
  };

  return (
    <PreferencesView
      dateFormat={user?.preferences?.date_format ?? "MM/dd/yyyy"}
      isLoading={isLoading}
      isSaving={isPending}
      theme={theme}
      onThemeChange={setTheme}
      onDateFormatChange={handleDateFormatChange}
    />
  );
}
